"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodeEnum = void 0;
var ErrorCodeEnum;
(function (ErrorCodeEnum) {
    ErrorCodeEnum["MISSING_PARAMETER"] = "MISSING_PARAMETER";
    ErrorCodeEnum["INVALID_PARAMETER"] = "INVALID_PARAMETER";
    ErrorCodeEnum["INVALID_USERNAME"] = "INVALID_USERNAME";
    ErrorCodeEnum["MISSING_PARAMETER_VALUE"] = "MISSING_PARAMETER_VALUE";
    ErrorCodeEnum["PENDING_VERIFICATION"] = "PENDING_CODE_VERIFICATION";
    ErrorCodeEnum["INVALID_PWD_RESET_CODE"] = "INVALID_PASSWORD_RESET_CODE";
    ErrorCodeEnum["INVALID_OLD_PWD"] = "INVALID_OLD_PASSWORD";
    ErrorCodeEnum["INVALID_CODE"] = "INVALID_CODE";
    ErrorCodeEnum["INVALID_TOKEN"] = "INVALID_TOKEN";
    ErrorCodeEnum["DEACTIVATED"] = "DEACTIVATED";
    ErrorCodeEnum["MISSING_TOKEN"] = "MISSING_TOKEN";
    ErrorCodeEnum["PENDING_CHANGE_PASSWORD"] = "PENDING_CHANGE_PASSWORD";
    ErrorCodeEnum["LOCKED"] = "LOCKED";
    ErrorCodeEnum["INVALID_EMAIL_FORMAT"] = "INVALID_EMAIL_FORMAT";
    ErrorCodeEnum["WEAK_PASSWORD"] = "WEAK_PASSWORD";
    ErrorCodeEnum["INVALID_CREDENTIAL"] = "INVALID_CREDENTIAL";
    ErrorCodeEnum["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    ErrorCodeEnum["USER_NOT_LOGGEDIN"] = "USER_NOT_LOGGEDIN";
    ErrorCodeEnum["INVALID_PHONE_NUMBER_FORMAT"] = "INVALID_PHONE_NUMBER_FORMAT";
    ErrorCodeEnum["USER_ALREADY_EXISTS"] = "USER_ALREADY_EXISTS";
})(ErrorCodeEnum = exports.ErrorCodeEnum || (exports.ErrorCodeEnum = {}));
//# sourceMappingURL=error.code.enum.js.map